import type { ReportSignal } from '../../../types/api';
import type { ComputedRecordLike } from './computedRecordTypes';

export const IMPORT_METADATA_PREFIXES = ['migration.', 'job.legacy_status', 'job.intake.'];

export const REPORT_KEY_SIGNAL_TYPES = [
    'financial.summary',
    'subject.financial.loan',
    'location.claimed',
    'job.outcome',
] as const;

export const SIGNAL_DISPLAY_ORDER = [
    'financial.summary',
    'subject.financial.loan',
    'subject.financial.obligations',
    'location.claimed',
    'job.outcome',
    'subject.contact',
    'subject.business_profile',
    'asset.equipment',
    'operational.business_hours',
    'operational.sales_velocity',
    'operational.shop_profile',
    'operational.payment_behavior',
    'visit.verification_summary',
    'job.legacy_status',
    'job.intake.request',
    'job.visitation_notes',
    'migration.identity',
    'migration.velocity.identity',
] as const;

export function isImportMetadataSignal(signalType: string): boolean {
    return IMPORT_METADATA_PREFIXES.some(
        (prefix) => signalType === prefix || signalType.startsWith(prefix),
    );
}

export function signalToRecord(signal: ReportSignal): ComputedRecordLike {
    return {
        id: signal.id,
        recordType: signal.signalType,
        recordValue: signal.signalValue ?? {},
        createdAt: signal.createdAt,
    };
}

export function findSignal(signals: ReportSignal[], signalType: string): ReportSignal | undefined {
    return signals.find((signal) => signal.signalType === signalType);
}

export function sortSignalsForDisplay(signals: ReportSignal[]): ReportSignal[] {
    const orderIndex = new Map(SIGNAL_DISPLAY_ORDER.map((type, index) => [type, index]));
    return [...signals].sort((a, b) => {
        const aIndex = orderIndex.get(a.signalType as (typeof SIGNAL_DISPLAY_ORDER)[number]) ?? 999;
        const bIndex = orderIndex.get(b.signalType as (typeof SIGNAL_DISPLAY_ORDER)[number]) ?? 999;
        if (aIndex !== bIndex) {
            return aIndex - bIndex;
        }
        return a.signalType.localeCompare(b.signalType);
    });
}
